import { SBCAAS_CLASSIC_LABEL, SBCAAS_MODERN_LABEL } from '@/constants/sbcaas';

export const serviceTypeRender = (rowData) => {
    switch (rowData.serviceType) {
        case 'ACSDirectRouting':
            return 'ACS Direct Routing';

        case 'TeamsPhoneMobile':
            return 'Teams Phone Mobile';

        case 'OperatorConnect':
            return 'Operator Connect';

        case 'DirectRouting':
            return 'Direct Routing';

        case 'SBCaaS':
            return SBCAAS_CLASSIC_LABEL;

        case 'SRT':
            return SBCAAS_MODERN_LABEL;

        case 'OperatorConnectConferencing':
            return 'Operator Connect Conferencing';

        case 'VendorDefined':
            return 'Vendor Defined';
        case 'ZoomPEX':
            return 'Zoom';
        case 'EightByEight':
            return '8x8';
        case 'RingCentral':
            return 'Ring Central';
        case 'DialPad':
            return 'Dial Pad';
        case 'OperatorPlatform':
            return 'Operator Platform';
        case 'DirectRoutingGCCH':
            return 'Direct Routing GCCH';
        case 'Webex':
            return 'Webex';
        default:
            return null;
    }
};

export const ZOOM = 'Zoom';
export const ZOOM_DISPLAY_NAME = 'Zoom PEX';
